<!--
  File name: DynamicFileInput.vue
  Program Description:
    - This component renders the file input for 'Other' documents.
  Includes:
    - Function that downloads uploaded documents.
    - Function that add/delete 'Other' field.
-->
<template>
  <v-form ref="form">
    <template v-if="!canUpload">
      <v-text-field
        v-for="fieldIndex in modelValue"
        :key="`{dynamic-field}-${fieldIndex}`"
        v-model="value[fieldIndex - 1]"
        :disabled="disabled"
        :rules="[v => !!v || 'Field must no be blank']"
        outlined
        class="ml-4"
      />
      <template v-if="!disabled">
        <v-btn
          class="ml-4 elevation-0"
          :disabled="modelValue <= 1"
          @click="$emit('input', removedLastIndex)"
        >
          <v-icon>
            mdi-minus
          </v-icon>
        </v-btn>
        <v-btn
          class="ml-2 elevation-0"
          color="primary"
          @click="$emit('input', [...value, ''])"
        >
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
      </template>
    </template>
    <template v-else>
      <template v-if="(canEdit || readonly) && !isDocumentSubmitted">
        <FileInputUpload
          v-for="label, fileIndex in othersLabels"
          :key="`{dynamic-file}-${fileIndex}`"
          v-model="value[fileIndex]"
          :show-download="showDownload"
          :entry-id="entryId"
          :readonly="readonly"
          :outlined="!readonly"
          :label="label.text || label"
          :rules="[required, max50mb]"
          :can-edit="canEdit || !readonly"
          dense
          clearable
          collection="pdbnf"
          input-class="required-field"
          field-name="othersAttachment"
          file-id="othersAttachmentFile"
          accept=".doc, .docx, .ppt, .pptx, .pdf, .xls, .xlsx, .png, .jpg, .jpeg'"
        />
      </template>
      <template v-else>
        <FileInputUpload
          v-for="file, fileIndex in value"
          :key="`{dynamic-file}-${fileIndex}`"
          :value="[file]"
          :entry-id="entryId"
          :show-download="showDownload"
          :readonly="readonly"
          :outlined="!readonly"
          :label="file.description"
          dense
          clearable
          can-view-file
          collection="pdbnf"
          input-class="required-field"
          field-name="othersAttachment"
          file-id="othersAttachmentFile"
          accept=".doc, .docx, .ppt, .pptx, .pdf, .xls, .xlsx, .png, .jpg, .jpeg'"
        />
      </template>
    </template>
  </v-form>
</template>

<script>
export default {
  name: 'DynamicFileInput',
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    othersLabels: {
      type: Array,
      default: () => ([])
    },
    disabled: {
      type: Boolean,
      default: false
    },
    canUpload: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    showDownload: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    },
    isDocumentSubmitted: {
      type: Boolean,
      default: true
    },
    entryId: {
      type: String,
      default: ''
    }
  },
  computed: {
    removedLastIndex () {
      const newVal = [...this.value].slice(0, -1)
      return newVal
    },
    required () {
      return file => !!file || 'Field must not be blank.'
    },
    max50mb () {
      return file => (file.size / 1024 / 1024) < 50 || 'Uploaded file exceeds the maximum file size: 50mb.'
    },
    modelValue () {
      if (!this.value) return 0
      return this.value.length
    }
  },
  methods: {
    validate () {
      return this.$refs.form && this.$refs.form.validate()
    }
  }
}
</script>
